import {Injectable} from "@angular/core";
import {Apollo, ApolloQueryObservable} from "apollo-angular";
import gql from "graphql-tag";
import {Observable} from "rxjs/Observable";
import {VisbosService} from "../../core/visbos-core/graphql/visbos.service";
import {Manufacturer} from "../../shared/view-model/crm/manufacturer";
import {NgRedux} from "@angular-redux/store";
import {IAppState} from "../../shared/redux-store";
import {SessionActions} from "../../shared/actions";
import {map} from "rxjs/operators";

export const manufacturerFragments = {
  manufacturer: gql`
    fragment ManufacturerFields on Manufacturer {
      cuid, name, label,
      address { cuid, label },
      administration_unit{ cuid, name, label }
    }`
};

export const fetchManufacturersQuery = gql`
  query FetchManufacturersQuery($AU: String, $cuid: String, $searchTerm: String) {
    fetchManufacturers(administration_unit_cuid: $AU, cuid: $cuid, search_string: $searchTerm){
      ...ManufacturerFields
    }
  }

  ${manufacturerFragments['manufacturer']}
`;

export interface FetchManufacturersResponse {
  fetchManufacturers: Manufacturer[];
}

@Injectable()
export class ManufacturerService extends VisbosService {

  constructor(apollo: Apollo, ngRedux: NgRedux<IAppState>, sessionActions: SessionActions) {
    super(apollo, ngRedux, sessionActions);
  }

  public getManufacturerList(administration_unit_cuid?: string | Observable<string>, searchTerm?: string | Observable<string>): ApolloQueryObservable<FetchManufacturersResponse> {

    let data$ = this.fetchItems<FetchManufacturersResponse>({
      query: fetchManufacturersQuery,
      variables: {
        AU: administration_unit_cuid,
        cuid: null,
        searchTerm: searchTerm
      }
    });

    return data$;
  }


  public getManufacturer(cuid: string): ApolloQueryObservable<Manufacturer> {

    let data$ = this.fetchItems<Manufacturer[]>({
      query: fetchManufacturersQuery,
      variables: {
        AU: null,
        cuid: cuid
      },
    });

    return <ApolloQueryObservable<Manufacturer>>data$.pipe(map(({data}: any) => data.fetchManufacturers[0]));
  }

  public createManufacturer(manufacturerInput): Observable<Manufacturer> {
    return this.mutate({
      mutation: gql`
        mutation CreateManufacturer($manufacturer: ManufacturerInput!) {
          addManufacturer(manufacturer: $manufacturer) {
            ...ManufacturerFields
          }
        }

        ${manufacturerFragments['manufacturer']}
      `,
      variables: {
        manufacturer: manufacturerInput
      },
      updateQueries: this.addItemsToQueries('fetchManufacturers', 'addManufacturer', ['FetchManufacturersQuery'])

    }).pipe(
      map(({data}: any) => {
        console.info("Added manufacturer #" + data.addManufacturer.cuid);
        return data.addManufacturer;
      })
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/crm/services/manufacturer.service.ts